/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable import/extensions */
import Head from 'next/head';
import Image from 'next/image';
import React, { createContext, useContext, useEffect, useReducer, useState, } from 'react';
import { Nav, Navbar, Button, Badge, Col, } from 'react-bootstrap';
import { FaCartShopping, FaCar } from 'react-icons/fa6';
import { MessagesContext } from '@/pages/_app';
import Cart from '@/components/actions/cart';
import Messages from '@/components/messages';
import Toasts from '@/components/toasts';
import DropdownProfile from '@/components/menus/dropdown-profile';
import { cart, help, http, layout, messages, store, } from '@/helpers/index';
import { auth } from '@/services/auth';
import Footer from '@/components/footer';
import Loading from '@/components/loading';
import HelpComponent from '../actions/help';
import ToolbarProfileComponent from '../menus/toolbar-profile';

export const CartContext = createContext(cart.init());
export const HelpContext = createContext(help.init());

export default function LayoutComponent({ code, children }) {
  const [state, dispatch] = useReducer(cart.reduce, cart.init());
  const { stateMessages, dispatchMessages } = useContext(MessagesContext);
  const value = { state, dispatch };
  const [stateHelp, dispatchHelp] = useReducer(help.reduce, help.init());
  const [showChild, setShowChild] = useState(false);
  const user = auth.store.logged.get();

  const titles = {
    myArea: 'Minha Área',
    leads: 'Leads',
    profile: 'Perfil',
    profileEdit: 'Editar Perfil',
    history: 'Histórico de Utilização',
    orders: 'Minhas Compras',
    products: 'Produtos Disponíveis',
    credit: 'Comprar Crédito',
    communication: 'Comunicação de Venda',
    diagnosis: 'Diagnósticos',
  };

  cart.configure(dispatch);
  help.configure(dispatchHelp);

  useEffect(() => {
    setShowChild(true);
    dispatch({ type: 'LOAD', });
    store.menu.crm.remove();
    if (!user) { return; }
    http.get('/helps', (result) => {
      if (result) {
        const items = [];
        result.forEach((el) => {
          if (el.category === 'GENERAL' || el.category === 'USER') {
            items.push(el);
          }
        });
        setTimeout(() => {
          help.dispatch({
            type: 'LOAD',
            payload: items,
          });
        }, 100);
      }
    });
  }, []);

  if (!showChild || typeof window === 'undefined') { return null; }

  return (
    <HelpContext.Provider value={{ stateHelp, dispatchHelp }}>
      <CartContext.Provider value={value}>
        <Head />
        <header className="profile">
          <Navbar id="navbar" bg="default" expand="md" fixed="top" className="ps-4 pe-4 shadow-sm">
            <Navbar.Brand href="/" onClick={layout.menu.close}>
              <Image src="/assets/themes/default/images/logo.png" width="247" height="55" border="0" alt="Logomarca da AboutCar" quality={75} />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className="not-printable pe-0" />
            <Col xs={12} className="mobile-cart not-printable">
              <div className="text-center">
                {state && state.quantity > 0 && (
                  <Button type="button" variant="light" size="sm" className="btn-cart mobile-cart me-1" onClick={() => layout.cart.show()}>
                    <FaCartShopping />
                    <Badge bg="light" className="ms-1 text-dark">
                      {state.quantity}
                    </Badge>
                  </Button>
                )}
                {user && <DropdownProfile />}
              </div>
            </Col>
            <Navbar.Collapse id="basic-navbar-nav" className="not-printable">
              <Nav className="me-auto not-printable ps-4">
                <Nav.Link href="/seminovos" onClick={layout.menu.close} className="nav-link-seminovos">
                  <FaCar className="me-1" />
                  Seminovos
                  <span className="seminovos-badge ms-1">NOVO</span>
                </Nav.Link>
                <Nav.Link href="/consultas-e-pacotes" onClick={layout.menu.close} className="rounded">Consultas e Pacotes</Nav.Link>
                <Nav.Link href="/parceria" onClick={layout.menu.close} className="rounded">Parceria</Nav.Link>
                <Nav.Link href="https://blog.aboutcar.com.br" target="_blank" rel="noreferrer" onClick={layout.menu.close} className="rounded">Blog</Nav.Link>
                <Nav.Link href="/contato" onClick={layout.menu.close} className="rounded">Contato</Nav.Link>
                <Nav.Link href="/acesse-seu-relatorio" onClick={layout.menu.close} className={user ? 'rounded' : 'rounded d-sm-none'}>Acesse seu Relatório</Nav.Link>
              </Nav>
              {state && state.quantity > 0 && (
                <Button type="button" variant="light" size="sm" className="btn-cart me-1 desktop-cart not-printable" onClick={() => layout.cart.show()}>
                  <FaCartShopping />
                  <Badge bg="light" className="ms-1 text-dark">
                    {state.quantity}
                  </Badge>
                </Button>
              )}
              {user && <div className="desktop-cart not-printable"><DropdownProfile /></div>}
            </Navbar.Collapse>
          </Navbar>
          <Cart state={state} />
          <HelpComponent state={stateHelp} />
        </header>
        <div className="profile container-fluid">
          <div className="row">
            <main className="ms-sm-auto px-md-4">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1>{titles[code]}</h1>
                <ToolbarProfileComponent />
              </div>
              <Messages items={stateMessages.messages} clear={messages.clear} />
              {children}
              <Footer className="profile text-center" profile />
            </main>
          </div>
        </div>
        <Loading />
        <Toasts items={stateMessages.messages} clear={messages.clear} />
      </CartContext.Provider>
    </HelpContext.Provider>
  );
}
